// extracted by mini-css-extract-plugin
export default {"snackBar":"SnackBarItem_snackBar__8iis+","snackbarInRight":"SnackBarItem_snackbarInRight__MLq9Y"};